import React, {Suspense, lazy, useEffect} from 'react';

import {hooks} from '../hooks';
import {components} from '../components';

const HomeScreen = lazy(async () => ({default: (await import('../screens/tabs/Home')).Home}));
const TransactionsScreen = lazy(async () => ({default: (await import('../screens/tabs/Transactions')).Transactions}));
const BraceletScreen = lazy(async () => ({default: (await import('../screens/tabs/Bracelet')).Bracelet}));
const TipsScreen = lazy(async () => ({default: (await import('../screens/tabs/Tips')).Tips}));
const ProfileScreen = lazy(async () => ({default: (await import('../screens/tabs/Profile')).Profile}));

export const TabNavigator: React.FC = () => {
  const screen = hooks.useAppSelector(
    (state) => state.tabSlice.screen,
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [screen]);

  return (
    <Suspense fallback={<components.TabLoader />}>
      <div>
        {screen === 'Home'         && <HomeScreen />}
        {screen === 'Transactions' && <TransactionsScreen />}
        {screen === 'Bracelet'     && <BraceletScreen />}
        {screen === 'Tips'         && <TipsScreen />}
        {screen === 'Profile'      && <ProfileScreen />}
      </div>
    </Suspense>
  );
};
